import React from "react";
import {
  StampCardsList,
  AddorEditStampCard,
  StampCardsDetails,
  AddorEditStampReward
} from "./containers";
import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "../../shared";

export const StampCards = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<StampCardsList />} />
        <Route path="/details/:id" element={<StampCardsDetails />} />
        <Route element={<ProtectedRoute allowedRoute={["surcharge-create"]} />}>
          <Route path="/create" element={<AddorEditStampCard />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoute={["surcharge-modify"]} />}>
          <Route path="/details/:id/edit" element={<AddorEditStampCard />} />
        </Route>
        <Route element={<ProtectedRoute allowedRoute={["surcharge-modify"]} />}>
          <Route
            path="/details/:id/reward/create"
            element={<AddorEditStampReward />}
          />
        </Route>
        <Route element={<ProtectedRoute allowedRoute={["surcharge-modify"]} />}>
          <Route
            path="/details/:id/reward/:rid/edit"
            element={<AddorEditStampReward />}
          />
        </Route>
      </Routes>
    </>
  );
};
